import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const mapStateToProps = (state) => {
    const {
        productPromo
    } = state.rootReducer.testPageDetails.thanksval;
    return {
        productPromo,
    }
}

const ProductPromo = ({
    productPromo: {
        offer_price,
        original_price,
        product_icon_url,
        product_tag_line,
        product_id,
    }
}) => {

    let offer_percent = '';
    if (offer_price === original_price) {
        offer_percent = ''
        original_price = '';
    } else {
        offer_percent = Math.round(((original_price - offer_price) / original_price) * 100) + '% off';
    }
    return (
        <div className="panel-body thank-you-product-box">
				<img src={product_icon_url} className="img-responsive course-list-img" alt="product_icon_img" />
				<div style={{marginBottom:"15px"}}>
					<span className="course-valid">{product_tag_line}</span>
				</div>
				<div>
					<div className="product-price-value">"₹ "{offer_price}</div>
					<span className="product-price-offer">"₹ "{original_price}</span>
					<span className="product-offer"> {offer_percent}</span>
					<div className="product-tax">Inclusive of Tax</div>
				</div>
				<Link to={'/purchase?productID='+product_id}>
					<div className="thank-you-product-btn" style={{cursor:"pointer"}}>
					Buy Now
					</div>
				</Link>
			</div>
    )

}
export default connect(mapStateToProps)(ProductPromo);